import { useEffect, useState } from "react";

/**
 * The line about reading the session - held back until the wait is long enough to be worth a word.
 *
 * Somebody who types the address has not asked to sign in and must not be met by a status line
 * about signing in. Reading the session is purely local since the silent iframe left the load path
 * (see `AuthContext.tsx`) and is done inside a frame, so on a plain visit there is nothing to
 * report. The one case that genuinely takes time is the way back from the sign-in redirect, where
 * the authorization code is exchanged over the network - and there the message is precisely what
 * the user is waiting for. A grace period tells the two apart, without either caller having to
 * know which one it is in.
 *
 * Not `PageFeedback`: that reports an event and then leaves on its own. This reports a state and
 * leaves when the state ends. It only declines to mention a state nobody would notice.
 */

/** Longer than any local check needs, short enough that the redirect back does not feel dead. */
const GRACE_PERIOD_MS = 400;

export default function AuthPending() {
  const [worthMentioning, setWorthMentioning] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setWorthMentioning(true), GRACE_PERIOD_MS);

    return () => window.clearTimeout(timer);
  }, []);

  if (!worthMentioning) return null;

  return <div className="page-feedback">Anmeldung wird geprüft...</div>;
}
